import React from "react";
import { getUser } from "../../state/User";
import { Link } from "react-router-dom";

export default function EnsureDestinations({
  children,
  campaign,
}: {
  children: any;
  campaign: Post;
}) {
  const user = getUser();

  if (!haveDestinations(user)) {
    return (
      <div className="tac mt2 mb2">
        <p className="tac mb2">
          You have no destinations yet.
          <small className="block">
            You need to link a network account in order to publish. Head to the{" "}
            <Link to="/destinations">destinations section</Link>.
            <br />
            You can still{" "}
            <Link to={`/campaigns/edit/${campaign.id}/content`}>
              add/upload your content
            </Link>{" "}
            tho. It's just you can't publish it from here.
          </small>
        </p>
      </div>
    );
  }
  return children;
}

export function haveDestinations(user: User | undefined | null) {
  return user && user.destinations && user.destinations.length > 0;
}
